<div
	class="w-full mx-auto bg-white rounded-r-md sm:py-12 sm:px-10 sm:min-h-[348px] flex flex-col justify-center"
	[ngClass]="{ 'border-y pt-8 sm:border-y-0': tab() === 'open-days' }"
>
	@if (uniSliderCopy()) {
		<div
			class="mb-5 sm:block"
			[ngClass]="{ block: tab() === 'open-days', hidden: tab() !== 'open-days' }"
		>
			@if (uniSliderCopy()?.heading) {
				<h3 class="mb-1 text-xl font-bold">
					{{ uniSliderCopy()?.heading }}
				</h3>
			}
			@if (uniSliderCopy()?.text) {
				<p class="text-gray-500">
					{{ uniSliderCopy()?.text }}
				</p>
			}
			@if (uniSliderCopy()?.subtitle) {
				<p class="text-gray-500">
					{{ uniSliderCopy()?.subtitle }}
				</p>
			}
		</div>
	}

	<div class="flex flex-col gap-3 pb-8 sm:pb-0 flex-nowrap">
		<!-- CTA slot -->
		<ng-content></ng-content>
	</div>
</div>
